import { ReactComponent as InvoiceIconSVG } from '@/assets/icons/InvoiceIcon.svg';
import { SVGProps } from 'react';

const InvoiceIcon = (props: SVGProps<SVGSVGElement>) => <InvoiceIconSVG {...props} />;

export default InvoiceIcon;
